import { ICompany } from '../common/data/dtos/company';
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/Company';

interface CompanyResponse {
	success: boolean;
	company?: ICompany;
	companies?: ICompany[];
	error?: string;
}

type CreateCompanyType = Omit<ICompany, 'id'> | Partial<ICompany>;

const createCompany = async (company: CreateCompanyType): Promise<CompanyResponse> => {
	try {
		const response = await POST_TYPED_ASYNC<ICompany>(`${BASE_PATH}`, company);
		return {
			success: response.success,
			...(!response.success ? { error: response.message || response.exception } : null),
		};
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const deleteCompany = async (id: string): Promise<CompanyResponse> => {
	try {
		const response = await DELETE_TYPED_ASYNC<ICompany>(`${BASE_PATH}/${id}`);

		return {
			success: response.success,
			...(!response.success ? { error: response.message || response.exception } : null),
		};
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const getCompanies = async (): Promise<CompanyResponse> => {
	try {
		const response = await GET_TYPED_ASYNC<ICompany>(`${BASE_PATH}`);

		if (!response.success) {
			return { success: response.success, error: response.message || response.exception };
		}

		return { success: response.success, companies: response.collection };
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const getOneCompany = async (id: string): Promise<CompanyResponse> => {
	try {
		const response = await GET_TYPED_ASYNC<ICompany>(`${BASE_PATH}?id=${id}`);

		if (!response.success) {
			return { success: response.success, error: response.message || response.exception };
		}

		return { success: response.success, company: response.entity };
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const updateCompany = async (company: ICompany): Promise<CompanyResponse> => {
	try {
		const response = await PUT_TYPED_ASYNC<ICompany>(`${BASE_PATH}/${company.id}`, company);
		return {
			success: response.success,
			...(!response.success ? { error: response.message || response.exception } : null),
		};
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

export default {
	createCompany,
	deleteCompany,
	getCompanies,
	getOneCompany,
	updateCompany,
};
